/**
 * Shared display formatters (numbers / strings). These were copy-pasted across
 * Chart, PositionsPanel and ManagementDashboard — consolidated here so they
 * stay consistent.
 *
 * All TIME formatters live in `chartTime.ts` (the single time source). The
 * four below are re-exported from here so existing `@/utils/format` imports
 * keep working — `fmtDate` is `chartTime.fmtLocalDate`.
 */
export {
  fmtCountdown,
  fmtAgo,
  fmtLocalDate as fmtDate,
  fmtLocalDateTime as fmtDateTime,
} from "./chartTime";

/** Signed P&L with 2 decimals: "+12.50" / "-3.00". */
export function fmtPnl(n: number): string {
  return (n >= 0 ? "+" : "") + n.toFixed(2);
}

/** Money with thousands separators + 2dp (no currency symbol). */
export function money(n: number): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Up-to-two-letter initials from a name (falls back to email / "?"). */
export function initials(name: string, email: string): string {
  const base = (name || email || "?").trim();
  const parts = base.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return base.slice(0, 2).toUpperCase();
}
